import React from 'react';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import { Box, xcss, Text } from '@atlaskit/primitives';
import { PaymentMethodTypeV2 } from '@css-xp/graphtypes';
import { FormattedDate } from '@css-xp/base';
import { getRouteUrl } from '@css-xp/ppc-utils';
import { routePaths } from '@css-xp/ppc-constants';

type PaymentFailureBannerProps = {
  transactionAccountId: string;
  invoiceGroupId: string | null;
  paymentMethodType: string;
  dueDate: string | null;
};

export const PaymentFailureBanner: React.FC<PaymentFailureBannerProps> = ({
  paymentMethodType,
  dueDate,
  transactionAccountId,
  invoiceGroupId,
}) => {
  let bannerTitle = 'Transaction declined';

  if (paymentMethodType.includes(PaymentMethodTypeV2.CARD)) {
    bannerTitle = 'Credit card transaction declined';
  } else if (paymentMethodType.includes(PaymentMethodTypeV2.PAYPAL)) {
    bannerTitle = 'PayPal transaction declined';
  }

  const billingProfileDetailsPageUrl = getRouteUrl(routePaths.billingProfileDetails, {
    txaId: transactionAccountId,
    billingProfileId: `${encodeURIComponent(invoiceGroupId ?? '')}`,
  });
  const updatePaymentMethodHref = `${billingProfileDetailsPageUrl}#details`;

  const transactionAccountDetailsPageUrl = getRouteUrl(routePaths.details, {
    txaId: transactionAccountId,
  });
  const editPaymentMethodHref = `${transactionAccountDetailsPageUrl}#payment-methods`;

  const actions = [
    <SectionMessageAction href={updatePaymentMethodHref} key="update-payment-method-action">
      Update payment method
    </SectionMessageAction>,
  ];
  if (paymentMethodType === PaymentMethodTypeV2.PAYPAL) {
    actions.push(
      <SectionMessageAction href={editPaymentMethodHref} key="edit-paypal-account-action">
        Edit PayPal account
      </SectionMessageAction>
    );
  }

  return (
    <Box xcss={xcss({ marginBottom: 'space.100' })}>
      <SectionMessage title={bannerTitle} appearance="error" actions={actions}>
        <Text>
          <span>
            To keep your subscriptions active, update your payment method before{' '}
            <strong>
              <FormattedDate date={dueDate} />
            </strong>
            .
          </span>
        </Text>
      </SectionMessage>
    </Box>
  );
};
